module.exports = __webpack_public_path__ + "img/alienware-laptop.d1df8fc3.jpg";